import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'
import { PerformanceReviewsDataTableDocument } from 'generated/resources/datatable.graphql'
import { DuplicatePerformanceReviewDocument } from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import type { ClosePortalFn } from 'modules/core/components/Portal/useCloseProxy'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

type Props = {
  reviewId: number
  onClose: () => void
}

export const DuplicateReviewModal: React.FC<Props> = ({ reviewId, onClose }) => {
  const { access } = useCurrentSession()

  const [duplicateReview, { loading }] = useMutation(DuplicatePerformanceReviewDocument, {
    extractorFn: (data) => data.performanceMutations.duplicatePerformanceReviewProcess,
  })

  const handleSubmit = async (closePortal: ClosePortalFn) => {
    const response = await duplicateReview({
      awaitRefetchQueries: true,
      variables: {
        id: reviewId,
        authorAccessId: access.id,
      },
      refetchQueries: [PerformanceReviewsDataTableDocument],
    })

    const handled = handleResult(response, () => undefined)

    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('performance_process.reviews.duplicate_review.modal.success_message'),
      })

      closePortal()
    }
  }

  return (
    <Modal
      title={i18n.t('performance_process.reviews.duplicate_review.modal.title')}
      description={i18n.t('performance_process.reviews.duplicate_review.modal.description')}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t('common.cancel')}
          </Button>
          <Button disabled={loading} submit>
            {i18n.t('performance_process.reviews.duplicate_review.modal.duplicate')}
          </Button>
        </>
      }
      illustration="alert"
      onClose={onClose}
      onSubmit={handleSubmit}
    />
  )
}
